export const PIN_BOARD_KEY = 'pinboard';
export const PIN_BOARD_ID_KEY = 'pinboardId';
export const PIN_BOARD_COMMENT_TYPE = 'Newsfeed';
// paths
export const NEWS_PATH = '/v1/news.json';
export const COMMUNITIES_PATH = '/v1/communities.json';
